module.exports = __webpack_public_path__ + "static/media/margerie4.af928a4d.jpg";